import { INITIAL_STAY_DATE, KPIOption, KpiSettingsDynamic, StayDateConfig } from "../interfaces/kpi";

export const uniqueId = () => Math.random().toString(36).substring(2, 9);

export const hasSubmenus = (kpiSettings: KPIOption): boolean => {
  return Object.entries(kpiSettings).some(([key, value]) => {
    if (key === 'date' || key === 'isActive') return false;
    if ((key === 'segment' || key === 'comparison') && Object.keys(value).length > 0) return true;
    if (key === 'stayDate') return true;
    if (typeof value === 'boolean') return true;
    return false;
  });
};

export const isKpiConfigEmpty = (kpiSettings: KpiSettingsDynamic): boolean => {
  const { segments = [], comparison = [], ...other } = kpiSettings;

  if (segments.length > 0 || comparison.length > 0) return false;

  for (const key in other) {
    const value = other[key];
    if (typeof value === 'boolean' && value === true) return false;
    if (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length > 0) return false;
  }
  return true;
};

export const findInitialStayDate = (userSettings: any[]): StayDateConfig => {
  for (const cfg of userSettings) {
    for (const kpiSettings of Object.values(cfg.settings)) {
      const s = kpiSettings as any;
      if (s.stayDate && s.stayDate.type && s.stayDate.value !== undefined) {
        return s.stayDate as StayDateConfig;
      }
    }
  }
  return INITIAL_STAY_DATE;
};

export const filterConfiguredKpis = (
  settings: Record<string, KpiSettingsDynamic>,
  ALL_KPI_OPTIONS: Record<string, KPIOption>
) =>
  Object.fromEntries(
    Object.entries(settings)
      .filter(([k, s]) => {
        const kpiOption = ALL_KPI_OPTIONS[k];
        if (!kpiOption) return false;

        if (!hasSubmenus(kpiOption)) {
          return true; 
        }
        return !isKpiConfigEmpty(s) || (s as any).stayDate;
      })
      .map(([k, s]) => {
        const filtered: Record<string, any> = {};

        if (s.segments?.length) filtered.segments = s.segments;
        if (s.comparison?.length) filtered.comparison = s.comparison;
        if ((s as any).stayDate) filtered.stayDate = (s as any).stayDate;

        Object.entries(s).forEach(([field, value]) => {
          if (field === 'stayDate' || field === 'segments' || field === 'comparison') return;

          if (typeof value === "boolean" && value === true) {
            filtered[field] = value;
          } else if (typeof value === "object" && !Array.isArray(value) && Object.keys(value).length > 0) {
            filtered[field] = value;
          }
        });

        if (Object.keys(filtered).length === 0 && !hasSubmenus(ALL_KPI_OPTIONS[k])) {
          return [k, {}];
        }

        return [k, filtered];
      })
  ) as Record<string, KpiSettingsDynamic>;